<template>
    <div
        :data-component-name="$options.name"
        :class="wrapperClasses"
        v-if="!disabledIDs.includes(field.id)"
    >
        <inputlabel :field="field" :showInstructions="true"/>

        <div class="o-form__item">
            <div class="o-radio__group"
                :class="{ '-is-horizontal': field.inputType === 'switch'}"
            >
                <div
                    class="o-radio__wrap"
                    v-for="(choice, ci) in choices"
                    :key="'cb-'+ci+'-'+field.id"
                    style="display: block;"
                >
                    <input
                        v-model="field.value"
                        class="o-radio"
                        :class="{ 'readonly': field.inputReadonly === true }"
                        v-on="readOnlyHandlers"
                        type="radio"
                        :id="'input-' +ci+'-'+field.id"
                        :name="field.inputName"
                        :placeholder="field.inputPlaceholder"
                        :value="(String(choice.value).trim() != '') ? choice.value : choice.text"
                        :required="(field.inputRequired === true) ? 'required' : false"
                        :checked="(field.value === choice.value || (choice.value=='' && field.value === choice.text)) ? 'checked' : false"
                        :autocomplete="(field.inputAutocomplete && field.inputAutocomplete != '' && field.inputAutocomplete != 'querystring' && field.inputAutocomplete != 'reactivevalue' && field.inputAutocomplete != 'cookie') ? field.inputAutocomplete : false"
                    >
                    <label class="o-radio-label" :for="'input-' + ci + '-' + field.id">
                        <span v-if="choice.picto && svgContentMap[choice.picto]">
                            <span v-html="svgContentMap[choice.picto]"></span>
                        </span>
                        <span v-html="(String(choice.text).trim() != '') ? choice.text : choice.value"></span>
                    </label>

                    <div class="o-form__validation">
                        <span class="o-form__validation__required">
                            {{ _t('Ce champ est obligatoire.') }}
                        </span>
                        <span class="o-form__validation__error">
                            {{ _t('Ce champ est invalide.') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'Input-radio',
    props: {
        field: {
            type: Object,
            default() {
                return {};
            },
        },
        disabledIDs: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            choices: [],
            svgContentMap: {}, // Store SVG markup by URL
            readOnlyHandlers: {
                keydown: this.handleEvent,
                paste: this.handleEvent,
                focus: this.handleEvent,
                mousedown: this.handleEvent,
            },
        };
    },
    mounted() {
        this.choices = this.field.inputSwitchChoices ? this.field.inputSwitchChoices : this.field.inputChoices;

        if (this.field.value === null) {
            let defaultValue = this.choices.find((choice) => choice.default);
            if (defaultValue) {
                this.field.value = String(defaultValue.value).trim() != '' ? defaultValue.value : defaultValue.text;
            }
        }

        // Fetch SVG contents for each choice's `picto` URL if available
        this.choices.forEach((choice) => {
            if (choice.picto && !this.svgContentMap[choice.picto]) {
                this.fetchSVGContent(choice.picto);
            }
        });
    },
    computed: {
        wrapperClasses() {
            let classes = '';

            if (!this.field.inputClass) {
                classes += 'o-grid-12 ';
            } else {
                classes += this.field.inputClass + ' ';
            }

            if (this.field.inputChoicesButtonStyle === true || this.field.inputType === 'switch') {
                classes += 'o-styled-input ';
            }
            
            if (this.field.inputType === 'inlineradio') {
                classes += 'o-inline-input ';
            }

            return classes;
        },
    },
    methods: {
        handleEvent(e) {
            if (this.field.inputReadonly === true && (!e.keyCode || e.keyCode != 9)) e.preventDefault();
        },
        async fetchSVGContent(url) {
            try {
                const response = await axios.get(url, { responseType: 'text' });
                this.svgContentMap[url] = response.data;
            } catch (error) {
                console.error(`Failed to load SVG from ${url}:`, error);
            }
        },
    },
};
</script>
